import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { setContext } from 'svelte';

var root = $.from_html(`<div><!></div>`);

export default function Radio_group_root($$anchor, $$props) {
	$.push($$props, true);

	let value = $.prop($$props, 'value', 15, ''),
		className = $.prop($$props, 'class', 3, '');

	setContext('radioGroup', {
		getValue: () => value(),

		setValue: (newValue) => {
			value(newValue);
		}
	});

	var div = root();
	var node = $.child(div);

	$.snippet(node, () => $$props.children ?? $.noop);
	$.reset(div);
	$.template_effect(() => $.set_class(div, 1, $.clsx(className())));
	$.append($$anchor, div);
	$.pop();
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsicmFkaW8tZ3JvdXAtcm9vdC5zdmVsdGUiXSwic291cmNlc0NvbnRlbnQiOlsiPHNjcmlwdCBsYW5nPVwidHNcIj5cbiAgaW1wb3J0IHsgc2V0Q29udGV4dCB9IGZyb20gJ3N2ZWx0ZSc7XG5cbiAgbGV0IHtcbiAgICB2YWx1ZSA9ICRiaW5kYWJsZSgnJyksXG4gICAgY2xhc3M6IGNsYXNzTmFtZSA9ICcnLFxuICAgIGNoaWxkcmVuLFxuICB9OiB7XG4gICAgdmFsdWU/OiBzdHJpbmc7XG4gICAgY2xhc3M/OiBzdHJpbmc7XG4gICAgY2hpbGRyZW4/OiBhbnk7XG4gIH0gPSAkcHJvcHMoKTtcblxuICBzZXRDb250ZXh0KCdyYWRpb0dyb3VwJywge1xuICAgIGdldFZhbHVlOiAoKSA9PiB2YWx1ZSxcbiAgICBzZXRWYWx1ZTogKG5ld1ZhbHVlOiBzdHJpbmcpID0+IHtcbiAgICAgIHZhbHVlID0gbmV3VmFsdWU7XG4gICAgfSxcbiAgfSk7XG48L3NjcmlwdD5cblxuPGRpdiBjbGFzcz17Y2xhc3NOYW1lfT5cbiAge0ByZW5kZXIgY2hpbGRyZW4/LigpfVxuPC9kaXY+XG4iXSwibWFwcGluZ3MiOiI7O1NBQ1csVUFBVSxRQUFRLFFBQVE7Ozs7NERBRHJDLENBQUM7OztLQUlHLEtBQUssZ0NBQWEsRUFBRTtFQUNiLFNBQVMsK0JBQUcsRUFBRTs7Q0FRdkIsVUFBVSxDQUFDLFlBQVk7RUFDckIsUUFBUSxRQUFRLEtBQUs7O0VBQ3JCLFFBQVEsR0FBRyxRQUFnQixLQUFLLENBQUM7R0FDL0IsS0FBSyxDQUFHLFFBQVE7RUFDbEIsQ0FBQzs7Ozs7Ozs7b0RBSU8sU0FBUzs7O0FBRnRCLENBQUMifQ==